import React from 'react'
import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'
import { requireNotNull } from '@shared/pipes/require-not-null'

import {
	RegionalPagesPath,
	regionalPagesProps,
} from '../../../regions/runtime-components/pages-props'
import { LoanNaZhileScreen } from '../../../screens/loan-na-zhile'
import { serverSideResolveCity } from '../../../ssr-resolvers/next-ssr-resolvers'

const PersonalPage: NextPageFC<Empty, PageLayoutOwnProps> = () => LoanNaZhileScreen()
const pageProps = requireNotNull(regionalPagesProps[RegionalPagesPath.personalNaZhile])
PersonalPage.layout = pageProps.layout
PersonalPage.headProps = pageProps.headProps

export const getServerSideProps = serverSideResolveCity

export default PersonalPage
